import React, { FC } from 'react';
import { View } from 'react-native';
import { scale } from '@components/frame';
import BatchNumberWithStatus, { BatchNumberWithStatusProps } from './BatchNumberWithStatus';
import LinkedInfo, { LinkedInfoProps } from './LinkedInfo';
import { BATCH_NUMBER_STATUS_LINKED_INFO_BLOCK_WIDTH } from '@v2/context/ProductionBatch/tile/constants';

interface BatchNumberStatusLinkedInfoBlockProps extends BatchNumberWithStatusProps, LinkedInfoProps {
  limitWidth?: boolean;
}

const BatchNumberStatusLinkedInfoBlock: FC<BatchNumberStatusLinkedInfoBlockProps> = ({
  C,
  batch,
  hovered,
  isWithERP,
  selectedItem,
  limitWidth = false,
}) => {
  return (
    <View
      style={[
        {
          flexDirection: 'row',
          gap: scale(9),
          alignItems: 'center',
          height: scale(25),
        },
        limitWidth && { minWidth: BATCH_NUMBER_STATUS_LINKED_INFO_BLOCK_WIDTH, width: BATCH_NUMBER_STATUS_LINKED_INFO_BLOCK_WIDTH },
      ]}
    >
      <BatchNumberWithStatus {...{ batch, C, hovered, isWithERP, selectedItem }} />
      <LinkedInfo {...{ links: batch.links, ncFileStatus: batch.ncFileStatus, C, isWithERP, hovered }} />
    </View>
  );
};

export { BatchNumberStatusLinkedInfoBlock };
